import type { Photo, Project } from "../types";

interface PhotoURI {
  uri?: string;
}

export const findSuitablePhoto = (project: Project, size: string = "small"): PhotoURI => {
  if (project.photo) {
    return { uri: project.photo };
  } else {
    if (!project.photos) {
      return {};
    }
    // Check for a 'favourite' shot
    const favourite = project.photos.find((photo) => photo.isFavourite);
    if (favourite) {
      return correctlySizedPhoto(favourite, size);
    }
    // Check for an 'after' shot

    // Check for an 'after' shot
    const after = project.photos.find((photo) => photo.type === "after");
    if (after) {
      return correctlySizedPhoto(after, size);
    }
    // Failing that... do we have a 'during'?
    const during = project.photos.find((photo) => photo.type === "during");
    if (during) {
      return correctlySizedPhoto(during, size);
    }
    // Failing that... let's just return the first one
    if (project.photos && project.photos[0] && project.photos[0].photo) {
      return correctlySizedPhoto(project.photos[0], size);
    }
  }
  return {};
};

export const correctlySizedPhoto = (photo: Photo | undefined, size: string = "small"): PhotoURI => {
  if (!photo) {
    return {};
  }
  if (size === "small" && photo.photo256) {
    return photo.photo256;
  }
  if ((size === "small" || size === "medium") && photo.photo1024) {
    return photo.photo1024;
  }
  return { uri: photo.photo };
};
